/**
© BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/
if (!customElements.get('blocky-accordion')) {
  customElements.define('blocky-accordion',
    class BlockyAccordion extends HTMLElement {
      constructor() {
        super();

        const buttons = this.querySelectorAll('.blocky-accordion-btn');

        buttons.forEach(button => {
          button.addEventListener('click', () => {
            const answer = button.nextElementSibling;
            const isActive = button.classList.contains('active');

            // ✅ Close all other accordions
            buttons.forEach(btn => {
              btn.classList.remove('active');
              btn.nextElementSibling.classList.remove('active');
            });

            // ✅ Toggle the clicked one (reopen if it was closed)
            if (!isActive) {
              button.classList.add('active');
              answer.classList.add('active');
            }
          });
        });
      }
    }
  );
}
